import { CurrentDataSources } from '@/pages/configure/data-sources/_partials/CurrentDataSources';

export default function DataSources() {
  return (
    <main data-testid="data-sources-page">
      <CurrentDataSources />
    </main>
  );
}
